module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external {"root":"isomorphic-fetch","commonjs2":"isomorphic-fetch","commonjs":"isomorphic-fetch","amd":"isomorphic-fetch"}
// module id = 5
// module chunks = 0